import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-set-notification-email',
  templateUrl: './set-notification-email.component.html',
  styleUrls: ['./set-notification-email.component.scss'],
})
export class SetNotificationEmailComponent implements OnInit {
  notificationEmail: string;
  notificationEnabled: boolean;
  forwardEnabled: boolean;
  emailAddress: string;

  inputForm: FormGroup;

  constructor() {
  }

  ngOnInit(): void {
    this.inputForm.addControl(
      'emails',
      new FormControl(this.notificationEmail ?? '', [Validators.required]),
    );
    this.inputForm.addControl(
      'notification',
      new FormControl(this.notificationEnabled),
    );
    this.inputForm.addControl('forward', new FormControl(this.forwardEnabled));
  }
}
